export const INELIGIBLE_CANDIDATE = {
  TITLE: "We're sorry.",
  SUBTITLE: "You're ineligible to join our network at this time.",
  DESCRIPTION:
    "Thanks for your interest in joining our network, however we're currently unable to onboard reviewers outside of the United States.",
  SUPPORT_SUBJECT: '[Reviewer Signup] Why am I ineligible to be a reviewer?',
};
